import type {TransactionHistory} from '../../generated/smg_service_pb';
import {colors} from '../assets/styles/colors';
import {formatCurrency} from './index';

type TransactionHistoryStatusInput = Pick<TransactionHistory, 'type' | 'status' | 'winAmount'>;

const withdrawalLabel = (status: string) => {
  if (status === 'PENDING') return 'In Review';
  if (status === 'UNKNOWN') return 'Unavailable';
  return status;
};

export const getTransactionHistoryStatusPresentation = (item: TransactionHistoryStatusInput, fullSwing: boolean) => {
  const isWithdrawal = item.type === 'WITHDRAWAL';

  let label = isWithdrawal ? withdrawalLabel(item.status) : item.status;
  if (item.status === 'RETURNED') label = 'CANCELLED';
  else if (item.status === 'WON') {
    label = `WON ${item.winAmount ? formatCurrency(Number(item.winAmount) / 100) : '$0'}`;
  }

  let color = 'white';
  if (item.status === 'COMPLETED') color = colors.greenText;
  else if (item.status === 'PENDING') color = fullSwing ? '#F2B824' : colors.lightBlue;
  else if (item.status === 'DECLINED' || item.status === 'LOST' || item.status === 'RETURNED') {
    color = fullSwing ? '#F55656' : colors.popupDangerPrimary;
  } else if (item.status === 'WON') color = fullSwing ? '#26B832' : colors.darkYellow;
  else if (isWithdrawal && item.status === 'UNKNOWN') color = fullSwing ? '#BBBCBF' : colors.gray;

  return {label, style: {color}};
};
